import * as React from "react";

const Document: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><g fill="#002554" fill-rule="nonzero"><path d="M12.563 4.813 8.186.438A.569.569 0 0 0 7.75.25H1.5C.81.25.25.81.25 1.5v15c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V5.25a.569.569 0 0 0-.188-.437ZM7.75 1.75l3.5 3.5h-3.5v-3.5ZM11.5 16.5h-10v-15h5v3.75c0 .69.56 1.25 1.25 1.25h3.75v10Z" /><path d="M3.375 12.75h6.25V14h-6.25v-1.25Zm0-3.75h6.25v1.25h-6.25V9Z" /></g></svg>
    );
};

export default React.memo(Document);
